import { centerActivityConstants, globalConstants } from "../../constants";

const initialState = {
  page: {},
  pageData: [],
  isViewModalOpen: false,
  activityData: [],
  activityDataById: {},
  calenderData:{},
};

const CenterActivityReducer = (state = initialState, action) => {
  switch (action.type) {
    case centerActivityConstants.VIEW_MODAL + globalConstants.SUCCESS:
      return {
        ...state,
        isViewModalOpen: action.data,
      };
    case centerActivityConstants.ACTIVITY_DATA_BY_ID + globalConstants.SUCCESS:
      return {
        ...state,
        activityDataById: action.data,
      };
    case centerActivityConstants.ACTIVITY_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        page: action.data.page,
        pageData: action.data.pageData,
        activityData: action.data,
      };
    case centerActivityConstants.CALENDER_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        calenderData:action.data,
      };
    default:
      return state;
  }
};

export default CenterActivityReducer;
